
/* React */
import React, { Component } from 'react';

/* Redux */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import { actions as ruleActions } from '../../redux/ducks/rule'

import { S } from '../../routes/routes';
import { SubViewHeaderStep } from '../../lib/components/subHeader';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

import { SizeMe } from 'react-sizeme';
import { CustomTableCell } from '../../custom/table';
import { getWidthColumnByPercent } from '../../lib/components/function';

import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { _N, isEmpty } from 'iotera-base/object';
import uuid from 'uuid'

class RuleCreateTrigger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      currentActionNew: {},
      currentActionResponse: {},
      currentActionWaiting: {},
      currentActionSolved: {},
      currentName: '',
      selectType: '',
      currentEmail: '',
      currentSubject: '',
      currentContent: '',
      currentNoHp: '',
      selectSubmit: '',
      createSetAction: {},
    }
    this.handleSubmitTambah = this.handleSubmitTambah.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDialogTrigger = this.handleDialogTrigger.bind(this);
    this.handleDialogTriggerNew = this.handleDialogTriggerNew.bind(this)
    this.handleDialogTriggerResponse = this.handleDialogTriggerResponse.bind(this)
    this.handleSubmitDialogAction = this.handleSubmitDialogAction.bind(this)
    this.handleChangeForm = this.handleChangeForm.bind(this)
    this.handleChangeFormName = this.handleChangeFormName.bind(this)
  }

  handleSubmitTambah() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { currentName, currentActionNew, currentActionResponse } = _state
    const currentAction = safeDeepGet(_props, ['action'], {});
    currentAction[uuid()] = {
      'name': currentName,
      'new': { ...currentActionNew },
      'response': { ...currentActionResponse }
    };
    _props.setCreateAction(currentAction);
    _props.history.replace('../action');
  }

  handleCancel() {
    this.props.history.replace('../action');
  }

  handleChange(event) {
    const _this = this
    const name = safeDeepGet(event, ['target', 'name'], '');
    const value = safeDeepGet(event, ['target', 'value'], '');
    if (name == 'type') {
      if (value == 'EMAIL') {
        _this.setState({
          selectType: 'Email'
        })
      }
      else if (value == 'WHATSAPP') {
        _this.setState({
          selectType: 'Whatsapp'
        })
      }
      else if (value == 'SMS') {
        _this.setState({
          selectType: 'SMS'
        })
      }
    }
  }

  handleChangeForm(event) {
    const _this = this;
    const _state = _this.state
    const { selectType } = _state
    const name = safeDeepGet(event, ['target', 'name'], '')
    const value = safeDeepGet(event, ['target', 'value'], '')
    if (selectType == 'Email') {
      if (name == 'email') {
        _this.setState({
          currentEmail: value
        })
      }
      else if (name == 'subject') {
        _this.setState({
          currentSubject: value
        })
      }
      else if (name == 'content') {
        _this.setState({
          currentContent: value
        })
      }
    }
    else if (selectType == 'Whatsapp' || selectType == 'SMS') {
      if (name == 'phone') {
        _this.setState({
          currentNoHp: value
        })
      }
      else if (name == 'content') {
        _this.setState({
          currentContent: value
        })
      }
    }
  }

  handleChangeFormName(event) {
    const value = safeDeepGet(event, ['target', 'value'], '')
    this.setState({
      currentName: value
    })
  }

  handleDialogTrigger() {
    const _this = this;
    const _state = _this.state
    const { dialogOpen } = _state
    _this.setState({
      dialogOpen: !dialogOpen,
    });
  }

  handleDialogTriggerNew() {
    const _this = this;
    const _state = _this.state
    const { dialogOpen } = _state
    _this.setState({
      dialogOpen: !dialogOpen,
      selectSubmit: 'new'
    });
  }

  handleDialogTriggerResponse() {
    const _this = this;
    const _state = _this.state
    const { dialogOpen } = _state
    _this.setState({
      dialogOpen: !dialogOpen,
      selectSubmit: 'response'
    });
  }

  handleSubmitDialogAction() {
    const _this = this;
    const _state = _this.state 
    const { currentActionNew, currentActionResponse, selectType, selectSubmit, 
      dialogOpen, currentEmail, currentSubject, currentContent, currentNoHp } = _state
    if (selectSubmit == 'new') {
      if (selectType == 'Email') {
        currentActionNew[uuid()] = {
          'type': selectType,
          'email': currentEmail,
          'subject': currentSubject,
          'content': currentContent,
        }
      }
      else if (selectType == 'Whatsapp' || selectType == 'SMS') {
        currentActionNew[uuid()] = {
          'type': selectType,
          'phone': currentNoHp,
          'content': currentContent,
        }
      }
    }
    else if (selectSubmit == 'response') {
      if (selectType == 'Email') {
        currentActionResponse[uuid()] = {
          'type': selectType,
          'email': currentEmail,
          'subject': currentSubject,
          'content': currentContent,
        }
      }
      else if (selectType == 'Whatsapp' || selectType == 'SMS') {
        currentActionResponse[uuid()] = {
          'type': selectType,
          'phone': currentNoHp,
          'content': currentContent,
        }
      }
    }
    _this.setState({
      currentActionNew: { ...currentActionNew },
      currentActionResponse: { ...currentActionResponse },
      dialogOpen: !dialogOpen
    });
  }

  renderEmail() {
    const _this = this
    const initEmail = '';
    const initSubject = '';
    const initContent = '';
    return <div>
      <FormControl required style={{ minWidth: '100%' }} >
        <TextField
          label="Email"
          defaultValue={initEmail}
          onChange={_this.handleChangeForm}
          margin='dense'
          type='email'
          inputProps={{ name: "email" }}
        />
      </FormControl>
      <FormControl required style={{ minWidth: '100%' }} >
        <TextField
          label="Subject"
          defaultValue={initSubject}
          onChange={_this.handleChangeForm}
          margin='dense'
          inputProps={{ name: "subject" }}
        />
      </FormControl>
      <FormControl required style={{ minWidth: '100%' }} >
        <TextField
          label="Content"
          defaultValue={initContent}
          onChange={_this.handleChangeForm}
          margin='dense'
          inputProps={{ name: "content" }}
        />
      </FormControl>
    </div>
  }

  renderWadanSMS() {
    const _this = this
    const initContent = '';
    const initNoHp = '';
    return <div>
      <FormControl required style={{ minWidth: '100%' }} >
        <TextField
          label="Phone Number"
          defaultValue={initNoHp}
          onChange={_this.handleChangeForm}
          margin='dense'
          type='number'
          inputProps={{ name: "phone" }}
        />
      </FormControl>
      <FormControl required style={{ minWidth: '100%' }} >
        <TextField
          label="Content"
          defaultValue={initContent}
          onChange={_this.handleChangeForm}
          margin='dense'
          inputProps={{ name: "content" }}
        />
      </FormControl>
    </div>
  }

  renderName() {
    const initName = '';
    return <FormControl required style={{ minWidth: '100%' }} >
      <TextField
        label="Name"
        defaultValue={initName}
        onChange={this.handleChangeFormName}
        margin='dense'
        inputProps={{ name: "name" }}
      />
    </FormControl>
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { currentActionNew, currentActionResponse, dialogOpen, selectType} = _state
    const info = safeDeepGet(_props, ['info'], {});
    if (isEmpty(info)) {
      _props.history.push('.' + S + 'info');
    }
    const currentActionNewSize = Object.keys(currentActionNew).length;
    const currentActionResponseSize = Object.keys(currentActionResponse).length;
    const initType = ''
    return (
      <div className="view">
        <SubViewHeaderStep title='Tambah Rule' subTitle='Rule Task' steps={['Info', 'Trigger', 'Action']} activeStep={2} />
        <div className="io-container mt-12" >
          {_this.renderName()}
          <br />
          <br />
          NEW
          <SizeMe>{({ size }) => <div>
            {currentActionNewSize > 0 &&
              <div>
                <Table className="table">
                  <TableHead style={{ height: 0 }}>
                    <TableRow>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(40, size.width - 140),
                        maxWidth: getWidthColumnByPercent(50, size.width - 140)
                      }}>
                        Type
                      </CustomTableCell>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(40, size.width - 140),
                        maxWidth: getWidthColumnByPercent(50, size.width - 140)
                      }}>
                        Info
                      </CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(currentActionNew).map((key) =>
                      <TableRow key={key} className='table-row-child-iotera'>
                        <TableCell >
                          {currentActionNew[key]['type']}
                        </TableCell>
                        <TableCell >
                          {currentActionNew[key]['email']}
                          {currentActionNew[key]['phone']}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>}
            <div className="button-right">
              <Button variant="outlined" type="button" size="large"
                style={{ minWidth: '0%' }}
                onClick={(e) => { this.handleDialogTriggerNew() }} >
                Add Task
              </Button>
            </div>
          </div>
          }</SizeMe>
          <br />
          <br />
          RESPONSE
          <SizeMe>{({ size }) => <div>
            {currentActionResponseSize > 0 &&
              <div>
                <Table className="table">
                  <TableHead style={{ height: 0 }}>
                    <TableRow>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(40, size.width - 140),
                        maxWidth: getWidthColumnByPercent(50, size.width - 140)
                      }}>
                        Type
                      </CustomTableCell>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(40, size.width - 140),
                        maxWidth: getWidthColumnByPercent(50, size.width - 140)
                      }}>
                        Info
                      </CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(currentActionResponse).map((key) =>
                      <TableRow key={key} className='table-row-child-iotera'>
                        <TableCell >
                          {currentActionResponse[key]['type']}
                        </TableCell>
                        <TableCell >
                          {currentActionResponse[key]['email']}
                          {currentActionResponse[key]['phone']}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>}
            <div className="button-right">
              <Button variant="outlined" type="button" size="large"
                style={{ minWidth: '0%' }}
                onClick={(e) => { _this.handleDialogTriggerResponse() }} >
                Add Task
              </Button>
            </div>
          </div>
          }</SizeMe>
          <br />
          <div className="button-right">
            <Button variant="outlined" type="button" size="large"
              style={{ minWidth: '0%' }}
              onClick={(e) => { _this.handleCancel() }} >Batal</Button>
            <Button variant="contained" size="large" color="primary" type="button"
              onClick={(e) => { _this.handleSubmitTambah() }} style={{ marginLeft: 10, minWidth: '0%' }}>Tambah</Button>
          </div>
          <Dialog
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            open={dialogOpen}
            aria-labelledby="max-width-dialog-title"
            fullWidth={true}
            maxWidth={'md'}
          >
            <DialogTitle id="form-dialog-title">
              <span>
                <span>Add Task</span>
              </span>
            </DialogTitle>
            <DialogContent >
              <FormControl required style={{ minWidth: '100%' }} >
                <InputLabel>Type</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  defaultValue={initType}
                  margin='dense'
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'type'
                  }}
                >
                  <MenuItem value='EMAIL'>EMAIL</MenuItem>
                  <MenuItem value='WHATSAPP'>WHATSAPP</MenuItem>
                  <MenuItem value='SMS'>SMS</MenuItem>
                </Select>
              </FormControl>
              {selectType == 'Email' ? _this.renderEmail() :
                selectType == 'Whatsapp' || selectType == 'SMS'
                  ? _this.renderWadanSMS() : null}
              <div className="button-right" style={{ marginTop: 20, marginBottom: 20 }}>
                <Button variant="outlined" type="button" size="large"
                  style={{ minWidth: '0%' }}
                  onClick={(e) => { _this.handleDialogTrigger() }}>Cancel</Button>
                <Button variant="contained" size="large" color="primary" type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}
                  onClick={(e) => { _this.handleSubmitDialogAction() }}>Add</Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    info: safeDeepGetWithType(state, ['rule', 'create_info'], {}),
    action: safeDeepGetWithType(state, ['rule', 'create_action'], {})
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...bindActionCreators(ruleActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RuleCreateTrigger));